import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { isMobile, currencyValue } from "utils/common";
import { getBulkQuoteData } from "store/priceQuote/actionCreator";
import Confirmation from "./confirmation";
import Button from "react-bootstrap/Button";
import alertIcon from "svg/red-alert-icon.svg";
import CustomTooltip from "common/tooltip";
import { api } from "store/slices/api";
import Modal from "common/modal";
import quote from "svg/quote.svg";
import { getUniqueQuoteData } from "../utils";
import "./style.scss";

const BulkUpdateQuote = () => {
  const { quoteId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [stage, setStage] = useState("bulkUpdate");
  const [mobileView, setMobileView] = useState(false);
  const [productsData, setProductsData] = useState();
  const [laborData, setLaborData] = useState();
  const [isDisabled, setIsDisabled] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const { data: quoteFields = {} } = api.useGetPriceQuoteQuery(quoteId);

  useEffect(() => {
    const handleResize = () => {
      if (!isMobile()) {
        setMobileView(false);
      } else {
        setMobileView(true);
      }
    };
    window.addEventListener("resize", handleResize);
    if (isMobile()) {
      handleResize();
    }
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [mobileView]);

  useEffect(() => {
    setTimeout(() => {
      let payload = {
        quoteId: quoteId,
        acctNbr: quoteFields?.accountNumber,
        prcNbr: quoteFields?.prcNumber,
        jobNumber: quoteFields?.jobNumber,
      };
      dispatch(getBulkQuoteData(payload)).then((res) => {
        const { uniqueProducts, uniqueLaborCodes } = getUniqueQuoteData(res);
        setProductsData(uniqueProducts);
        setLaborData(uniqueLaborCodes);
      });
    }, 0);
  }, [quoteId, quoteFields?.accountNumber, quoteFields?.prcNumber, quoteFields?.jobNumber]);

  const handleSummaryPage = () => {
    navigate(`/priceQuote/${quoteId}#quote-summary`);
  };

  const handleCancel = () => {
    setShowModal(false);
  };

  const handleSave = () => {
    setStage("confirmation");
    setShowModal(false);
  };

  const handleNextTab = () => {
    let hasZeroVal = false;
    if (productsData.length && laborData.length) {
      productsData.some((product) => {
        return laborData.some((labor) => {
          if (
            parseFloat(product.editedPrice).toFixed(2) === parseFloat("0").toFixed(2) ||
            parseFloat(labor.editedPrice).toFixed(2) === parseFloat("0").toFixed(2)
          ) {
            hasZeroVal = true;
          }
          return (
            parseFloat(product.editedPrice).toFixed(2) === parseFloat("0").toFixed(2) ||
            parseFloat(labor.editedPrice).toFixed(2) === parseFloat("0").toFixed(2)
          );
        });
      });
    } else if (productsData.length && !laborData.length) {
      productsData.some((product) => {
        if (parseFloat(product.editedPrice).toFixed(2) === parseFloat("0").toFixed(2)) {
          hasZeroVal = true;
        }
        return parseFloat(product.editedPrice).toFixed(2) === parseFloat("0").toFixed(2);
      });
    } else if (!productsData.length && laborData.length) {
      laborData.some((labor) => {
        if (parseFloat(labor.editedPrice).toFixed(2) === parseFloat("0").toFixed(2)) {
          hasZeroVal = true;
        }
        return parseFloat(labor.editedPrice).toFixed(2) === parseFloat("0").toFixed(2);
      });
    }
    if (hasZeroVal) {
      setShowModal(true);
    } else {
      setStage("confirmation");
    }
  };

  const handleChangeProduct = (e, data) => {
    const value = e.target.value;
    let productArr = JSON.parse(JSON.stringify(productsData));
    productArr.map((element) => {
      if (element.productId === data.productId) {
        element.editedPrice = value;
      }
    });
    setProductsData(productArr);
  };

  const handleChangeLabor = (e, data) => {
    const value = e.target.value;
    let laborArr = JSON.parse(JSON.stringify(laborData));
    laborArr.map((element) => {
      if (element.laborCodeId === data.laborCodeId) {
        element.editedPrice = value;
      }
    });
    setLaborData(laborArr);
  };

  useEffect(() => {
    const handleWheel = (e) => {
      if (e.target.type === "number") {
        e.preventDefault();
      }
    };
    window.addEventListener("wheel", handleWheel, { passive: false });
    return () => {
      window.removeEventListener("wheel", handleWheel);
    };
  }, []);

  useEffect(() => {
    let flag = true;
    if (laborData?.some((e) => e.editedPrice)) {
      flag = false;
    }
    if (productsData?.some((e) => e.editedPrice)) {
      flag = false;
    }
    setIsDisabled(flag);
  }, [laborData, productsData]);

  return (
    <>
      {stage === "bulkUpdate" && (
        <div className="container-fluid search-form-container">
          <div className="search-form-container__title">
            <span className="search-form-container__title--text">
              <img src={quote} alt="quote" />
              &nbsp;Bulk Update Price
            </span>
          </div>
          {productsData?.length > 0 && <div className="bulk-header">Material Items</div>}
          {productsData?.map((data, index) => {
            return (
              <div className="bulkUpdateQuote_container" key={index + data.productName}>
                <div className="row bulkUpdateQuote_container__floor_area">
                  <div className="d-md-flex flex-column flex-md-row mt-5 mt-md-0 overflow-auto position-relative">
                    <div className="d-flex flex-row flex-md-column info-item justify-content-between justify-content-md-start col-12 col-md-2">
                      <div className="info-item__label">Sales Number</div>
                      <div className="info-item__value text-end text-md-start">
                        {!data.salesNumber ? "N/A" : data.salesNumber}
                      </div>
                    </div>
                    <div className="d-flex flex-row flex-md-column info-item justify-content-between justify-content-md-start col-12 col-md-4">
                      <div className="info-item__label">Product Name</div>
                      <div className="info-item__value text-end text-md-start prod-name">{data.productName}</div>
                    </div>
                    <div className="d-flex flex-row flex-md-column info-item justify-content-between justify-content-md-start col-12 col-md-2">
                      <div className="info-item__label">Current Price</div>
                      <div className={`${data.price === 0 ? "price-txt" : ""} info-item__value text-end text-md-start`}>
                        {currencyValue(data.price)}
                        {data.isPriceVaries && (
                          <CustomTooltip placement="top" trigger="hover" text={"Price varies between Floor Plans"}>
                            <span>
                              <img className="alert_style" src={alertIcon} />
                            </span>
                          </CustomTooltip>
                        )}
                        {data.price === 0 && (
                          <CustomTooltip placement="top" trigger="hover" text={"Price is 0"}>
                            <span>
                              <img className="alert_style" src={alertIcon} />
                            </span>
                          </CustomTooltip>
                        )}
                      </div>
                    </div>
                    <div className="d-flex flex-row flex-md-column info-item justify-content-between justify-content-md-start col-12 col-md-2">
                      <div className="info-item__label">New Price</div>
                      <input
                        type="number"
                        className="info-item__input"
                        onChange={(e) => handleChangeProduct(e, data)}
                        value={data.editedPrice || ""}
                      />
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
          {laborData?.length > 0 && <div className="bulk-header footer-spacing">Labor Items</div>}
          {laborData?.map((data, index) => {
            return (
              <div className="bulkUpdateQuote_container" key={index + data.laborCode}>
                <div className="row bulkUpdateQuote_container__floor_area">
                  <div className="d-md-flex flex-column flex-md-row mt-5 mt-md-0 overflow-auto position-relative">
                    <div className="d-flex flex-row flex-md-column info-item justify-content-between justify-content-md-start col-12 col-md-2">
                      <div className="info-item__label">Labor Code</div>
                      <div className="info-item__value text-end text-md-start">{data.laborCode}</div>
                    </div>
                    <div className="d-flex flex-row flex-md-column info-item justify-content-between justify-content-md-start col-12 col-md-4">
                      <div className="info-item__label">Description</div>
                      <div className="info-item__value text-end text-md-start">{data.description}</div>
                    </div>
                    <div className="d-flex flex-row flex-md-column info-item justify-content-between justify-content-md-start col-12 col-md-2">
                      <div className="info-item__label">Current Price</div>
                      <div className={`${data.price === 0 ? "price-txt" : ""} info-item__value text-end text-md-start`}>
                        {currencyValue(data.price)}
                        {data.isPriceVaries && (
                          <CustomTooltip placement="top" trigger="hover" text={"Price varies between Floor Plans"}>
                            <span>
                              <img className="alert_style" src={alertIcon} />
                            </span>
                          </CustomTooltip>
                        )}
                        {data.price === 0 && (
                          <CustomTooltip placement="top" trigger="hover" text={"Price is 0"}>
                            <span>
                              <img className="alert_style" src={alertIcon} />
                            </span>
                          </CustomTooltip>
                        )}
                      </div>
                    </div>
                    <div className="d-flex flex-row flex-md-column info-item justify-content-between justify-content-md-start col-12 col-md-2">
                      <div className="info-item__label">New Price</div>
                      <input
                        type="number"
                        aria-label="price"
                        className="info-item__input"
                        onChange={(e) => handleChangeLabor(e, data)}
                        value={data.editedPrice || ""}
                      />
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
          {!productsData?.length && !laborData?.length && (
            <p className="no-items">There are no products and labor codes for this Quote.</p>
          )}
          <div className="d-flex justify-content-between flex-column flex-md-row mt-10 footer-spacing">
            <Button variant="outline-primary" onClick={handleSummaryPage}>
              Back
            </Button>
            <Button onClick={handleNextTab} disabled={isDisabled}>
              Next
            </Button>
          </div>
        </div>
      )}

      {stage === "confirmation" && (
        <Confirmation setStage={setStage} productsData={productsData} laborData={laborData} />
      )}

      {showModal && (
        <Modal
          title={"Are you sure?"}
          saveButtonText={"Confirm"}
          closeButtonText={"Cancel"}
          handleSave={handleSave}
          handleCancel={handleCancel}
          size={mobileView ? "sm" : "lg"}
        >
          <p className="confirmation-text">
            One or more Products/Labor codes have price $0.00. Do you want to continue?
          </p>
        </Modal>
      )}
    </>
  );
};

export default BulkUpdateQuote;
